/**
 *
 * This jQuery plugin was inspired and based on Lightbox 2 by Lokesh Dhakar (http://www.huddletogether.com/projects/lightbox2/)
 * and adapted to me for use like a plugin from jQuery.
 * name jquery-lightbox-0.5.js
 * @author Leandro Vieira Pinho - http://leandrovieira.com
 * @version 0.5
 * @date April 11, 2008
 * @category jQuery plugin
 * @copyright (c) 2008 Leandro Vieira Pinho (leandrovieira.com)
 * @license CCAttribution-ShareAlike 2.5 Brazil - http://creativecommons.org/licenses/by-sa/2.5/br/deed.en_US
 * Visit http://leandrovieira.com/projects/jquery/lightbox/ for more informations about this jQuery plugin
 */
 /** 
 * This jQuery plugin was inspired and based on Lightbox 2 by Lokesh Dhakar (http://www.huddletogether.com/projects/lightbox2/)
 * and adapted to me for use like a plugin from jQuery.
 * name jquery-lightbox-0.5.js
 * 
 *  <p>Modified by Robert Blackwell (rob@whiteacorn.com)
 *	<ol>
 * <li>.	A new option has been added settings.cycle_thru_images. When true next/prev dont stop at start or end but keep cycling through the images.
 *	<li>	There was a bug in the function _keyboard_action - with safari it did not find the value of the ESC key correctly
 *	<li>	keydown events were not being handled correctly in a siutation where other code (non Lightbox) also had keydown handlers installed.
 *		The fix was:
        <ul>
 *			<li>stop events proagating up from the keydown handler while lightbox was running
 *			<li>when closing lightbox only unhook the lightbox keydown handler, that requires using an unbind call with the handler
 *				specific  such as .unbind("keydown", _keyboard_action)
 *      </ul>
 *	<li>	The inserted html is formated for easy reading
 *  <li>  Modified to accept rel=lightbox[a group id] so that multiple image sets can appear on a single page
 *  </ol>
 *	<p>I have tried to identify all my changes with the text Robert Blackwell inside a comment near the place a change has been made
 *
 *  <p>Offering a Custom Alias suport. For more info see <strong>http://docs.jquery.com/Plugins/Authoring#Custom_Alias</strong>
 *
 * @name jQuery.lightBox
 * @namespace
 */
(function($) {
/**
* This function is being added to jQuery as an addin
* @name lightBox
* @function 
*/
	$.fn.lightBox = function(settings) {
		// Settings to configure the jQuery lightBox plugin how you like
		settings = jQuery.extend({
			// Configuration related to overlay
			overlayBgColor: 		'#000',		// (string) Background color to overlay; inform a hexadecimal value like: #RRGGBB. Where RR, GG, and BB are the hexadecimal values for the red, green, and blue values of the color.
			overlayOpacity:			0.8,		// (integer) Opacity value to overlay; inform: 0.X. Where X are number from 0 to 9
			// Configuration related to navigation
			fixedNavigation:		true,		// (boolean) Boolean that informs if the navigation (next and prev button) will be fixed or not in the interface.
			// Configuration related to images
			// Robert Blackwell - the image locations have been changed for my site
			imageLoading:			'/skins/theamericas/js/jquery-lightbox-0.5/images/lightbox-ico-loading.gif',	// (string) Path and the name of the loading icon
			imageBtnPrev:			'/skins/theamericas/js/jquery-lightbox-0.5/images/lightbox-btn-prev.gif',		// (string) Path and the name of the prev button image
			imageBtnNext:			'/skins/theamericas/js/jquery-lightbox-0.5/images/lightbox-btn-next.gif',		// (string) Path and the name of the next button image
			imageBtnClose:			'/skins/theamericas/js/jquery-lightbox-0.5/images/lightbox-btn-close.gif',	// (string) Path and the name of the close btn
			imageBlank:				'/skins/theamericas/js/jquery-lightbox-0.5/images/lightbox-blank.gif',		// (string) Path and the name of a blank image (one pixel)
			// Configuration related to container image box
			containerBorderSize:	10,			// (integer) If you adjust the padding in the CSS for the container, #lightbox-container-image-box, you will need to update this value
			containerResizeSpeed:	400,		// (integer) Specify the resize duration of container image. These number are miliseconds. 400 is default.
			// Configuration related to texts in caption. For example: Image 2 of 8. You can alter either "Image" and "of" texts.
			txtImage:				'Image',	// (string) Specify text "Image"
			txtOf:					'of',		// (string) Specify text "of"
			// Configuration related to keyboard navigation
			keyToClose:				'c',		// (string) (c = close) Letter to close the jQuery lightBox interface. Beyond this letter, the letter X and the SCAPE key is used to.
			keyToPrev:				'p',		// (string) (p = previous) Letter to show the previous image
			keyToNext:				'n',		// (string) (n = next) Letter to show the next image.
			// Don�t alter these variables in any way
			imageArray:				[],
			activeImage:			0,
			cycle_thru_images:		true		// if true the next/prev commands cycle around and start again. If false they stop at the 1st and last image respectively
		},settings);
		// Caching the jQuery object with all elements matched
		var jQueryMatchedObj = this; // This, in this context, refer to jQuery object

        /**
         * Initializing the plugin calling the start function
         * @name initialize
         * @function
         */
        function _initialize() {
            _start(this,jQueryMatchedObj); // This, in this context, refer to object (link) which the user have clicked
            return false; // Avoid the browser following the link
        }
		/**
		* Robert Blackwell - computes the index of the next image taking settings.cycle_thru_images into account
		* @name _next_image
		* @returns index value of next image
		* @method
		*/
		function _next_image(){
			if (settings.cycle_thru_images)
				result = (settings.activeImage == (settings.imageArray.length-1))? 0: settings.activeImage + 1;
			else
				result = (settings.activeImage == (settings.imageArray.length-1))? (settings.imageArray.length-1): settings.activeImage + 1;
			return result;
		}
		/**
		* Robert Blackwell
		* Sets the activeImage value to the next image taking settings.cycle_thru_images into account
		*/
		function _set_next_image(){
				settings.activeImage = _next_image();
		}
		/**
		* Robert Blackwell
		* Computes the index of the prev image taking settings.cycle_thru_images into account
		*/
		function _prev_image(){
			if (settings.cycle_thru_images)
				result = (settings.activeImage != 0)? settings.activeImage - 1 : settings.imageArray.length - 1;
			else
				result = (settings.activeImage != 0)? settings.activeImage - 1 : 0;				
			return result;
		}
		/**
		* Robert Blackwell
		* Sets the activeImage value to the prev image taking settings.cycle_thru_images into account
		*/
		function _set_prev_image(){
				settings.activeImage = _prev_image();
		}
		/**
		 * Start the jQuery lightBox plugin
		 *
		 * @param object objClicked The object (link) whick the user have clicked
		 * @param object jQueryMatchedObj The jQuery object with all elements matched
		 */
		function _start(objClicked,jQueryMatchedObj) {
			// Hime some elements to avoid conflict with overlay in IE. These elements appear above the overlay.
			$('embed, object, select').css({ 'visibility' : 'hidden' });
			// Call the function to create the markup structure; style some elements; assign events in some elements.
			_set_interface();
			// Unset total images in imageArray
			settings.imageArray.length = 0;
			// Unset image active information
			settings.activeImage = 0;
			// We have an image set? Or just an image? Let�s see it.
			if ( jQueryMatchedObj.length == 1 ) {
				settings.imageArray.push(new Array(objClicked.getAttribute('href'),objClicked.getAttribute('title')));
			} else {
				// Add an Array (as many as we have), with href and title atributes, inside the Array that storage the images references		
				for ( var i = 0; i < jQueryMatchedObj.length; i++ ) {
					r1 = objClicked.rel;
					r2 = jQueryMatchedObj[i].rel;
					if (r1 == r2)
						settings.imageArray.push(new Array(jQueryMatchedObj[i].getAttribute('href'),jQueryMatchedObj[i].getAttribute('title')));
				}
			}
			// find the index value for the object that was clicked
			while ( settings.imageArray[settings.activeImage][0] != objClicked.getAttribute('href') ) {
				settings.activeImage++;
			}
			// Call the function that prepares image exibition
			//$("#jquery-lightbox").overlay({top: 50});
			
			_set_image_to_view();
		}
		/**
		 * Create the jQuery lightBox plugin interface
		 *
		 * The HTML markup will be like that:
			<div id="jquery-overlay"></div>
			<div id="jquery-lightbox">
				<div id="lightbox-container-image-box">
					<div id="lightbox-container-image">
						<img src="../fotos/XX.jpg" id="lightbox-image">
						<div id="lightbox-nav">
							<a href="#" id="lightbox-nav-btnPrev"></a>
							<a href="#" id="lightbox-nav-btnNext"></a>
						</div>
						<div id="lightbox-loading">
							<a href="#" id="lightbox-loading-link">
								<img src="../images/lightbox-ico-loading.gif">
							</a>
						</div>
					</div>
				</div>
				<div id="lightbox-container-image-data-box">
					<div id="lightbox-container-image-data">
						<div id="lightbox-image-leftNav">
							<a href="#" id="lightbox-leftNav-btnPrev">
								<img src="../images/lightbox-btn-prev.gif">
							</a>
							<a href="#" id="lightbox-secNav-btnNext">
								<img src="../images/lightbox-btn-next.gif">
							</a>
						</div>
						<div id="lightbox-image-details">
							<span id="lightbox-image-details-caption"></span>
							<span id="lightbox-image-details-currentNumber"></span>
						</div>
						<div id="lightbox-secNav">
							<a href="#" id="lightbox-secNav-btnClose">
								<img src="../images/lightbox-btn-close.gif">
							</a>
						</div>
					</div>
				</div>
			</div>
		 *
		 */
		function _set_interface() {
			// Apply the HTML markup into body tag
			// This is the html expanded so I can read it
			html2 = 
			'<div id="jquery-overlay"></div>\n'+
			'<div id="jquery-lightbox">\n'+
			'	<div id="lightbox-container-image-box">\n'+
			'		<div id="lightbox-container-image">\n'+
			'			<img id="lightbox-image">\n'+
			'			<div style="" id="lightbox-nav">\n'+
			'				<a href="#" id="lightbox-nav-btnPrev"></a>\n'+
			'				<a href="#" id="lightbox-nav-btnNext"></a>\n'+
			'			</div>\n'+
			'			<div id="lightbox-loading">\n'+
			'				<a href="#" id="lightbox-loading-link">\n'+
			'				<img src="' + settings.imageLoading + '"></a>\n'+
			'			</div>\n'+
			'		</div>\n'+
			'	</div>\n'+
			'	<div id="lightbox-container-image-data-box">\n'+
			'		<div id="lightbox-container-image-data" >\n'+
			'			<div id="lightbox-image-details">\n'+ 
			'				<span id="lightbox-image-details-caption"></span>\n'+
			'				<span id="lightbox-image-details-currentNumber"></span>\n'+
			'			</div>\n'+
			'			<div id="lightbox-secNav">\n'+ 
			'				<a href="#" id="lightbox-secNav-btnClose"><img src="' + settings.imageBtnClose + '"></a>\n'+
			'			</div>\n'+
			'		</div>\n'+
			'	</div>\n'+
			'</div>';	
			
			$('body').append(html2);

			// Get page sizes
			var arrPageSizes = ___getPageSize();
			// Style overlay and show it
			$('#jquery-overlay').css({
				backgroundColor:	settings.overlayBgColor,
				opacity:			settings.overlayOpacity,
				width:				arrPageSizes[0],
				height:				arrPageSizes[1]
			}).fadeIn();
			// Get page scroll
			var arrPageScroll = ___getPageScroll();
			// Calculate top and left offset for the jquery-lightbox div object and show it
			$('#jquery-lightbox').css({
				top:	arrPageScroll[1] + (arrPageSizes[3] / 10),
				left:	arrPageScroll[0]
			}).show();
			// Assigning click events in elements to close overlay
			$('#jquery-overlay,#jquery-lightbox').click(function() {
				_finish();									
			});
			// Assign the _finish function to lightbox-loading-link and lightbox-secNav-btnClose objects
			$('#lightbox-loading-link,#lightbox-secNav-btnClose').click(function() {
				_finish();
				return false;
			});
			// If window was resized, calculate the new overlay dimensions
			$(window).resize(function() {
				// Get page sizes
				var arrPageSizes = ___getPageSize();
				// Style overlay and show it
				$('#jquery-overlay').css({
					width:		arrPageSizes[0],
					height:		arrPageSizes[1]
				});
				// Get page scroll
				var arrPageScroll = ___getPageScroll();
				// Calculate top and left offset for the jquery-lightbox div object and show it
				$('#jquery-lightbox').css({
					top:	arrPageScroll[1] + (arrPageSizes[3] / 10),
					left:	arrPageScroll[0]
				});
			});
		}
		/**
		 * Prepares image exibition; doing a image�s preloader to calculate it�s size
		 *
		 */
		function _set_image_to_view() { // show the loading
			// Show the loading
			$('#lightbox-loading').show();
			if ( settings.fixedNavigation ) {
				$('#lightbox-image,#lightbox-container-image-data-box,#lightbox-image-details-currentNumber').hide();
			} else {
				// Hide some elements
				$('#lightbox-image,#lightbox-nav,#lightbox-nav-btnPrev,#lightbox-nav-btnNext,#lightbox-container-image-data-box,#lightbox-image-details-currentNumber').hide();
			}
			// Image preload process
			var objImagePreloader = new Image();
			objImagePreloader.onload = function() {
				$('#lightbox-image').attr('src',settings.imageArray[settings.activeImage][0]);
				// Perfomance an effect in the image container resizing it
				_resize_container_image_box(objImagePreloader.width,objImagePreloader.height);
				//	clear onLoad, IE behaves irratically with animated gifs otherwise
				objImagePreloader.onload=function(){};
			};
			objImagePreloader.src = settings.imageArray[settings.activeImage][0];
		};
		/**
		 * Perfomance an effect in the image container resizing it
		 *
		 * @param integer intImageWidth The image�s width that will be showed
		 * @param integer intImageHeight The image�s height that will be showed
		 */
		function _resize_container_image_box(intImageWidth,intImageHeight) {
			// Get current width and height
			var intCurrentWidth = $('#lightbox-container-image-box').width();
			var intCurrentHeight = $('#lightbox-container-image-box').height();
			// Get the width and height of the selected image plus the padding
			var intWidth = (intImageWidth + (settings.containerBorderSize * 2)); // Plus the image�s width and the left and right padding value
			var intHeight = (intImageHeight + (settings.containerBorderSize * 2)); // Plus the image�s height and the left and right padding value
			// Diferences
			var intDiffW = intCurrentWidth - intWidth;
			var intDiffH = intCurrentHeight - intHeight;
			// Perfomance the effect
			$('#lightbox-container-image-box').animate({ width: intWidth, height: intHeight },settings.containerResizeSpeed,function() { _show_image(); });
			if ( ( intDiffW == 0 ) && ( intDiffH == 0 ) ) {
				if ( $.browser.msie ) {
					___pause(250);
				} else {
					___pause(100);	
				}
			} 
			$('#lightbox-container-image-data-box').css({ width: intImageWidth });
			$('#lightbox-nav-btnPrev,#lightbox-nav-btnNext').css({ height: intImageHeight + (settings.containerBorderSize * 2) });
		};
		/**
		 * Show the prepared image
		 *
		 */
		function _show_image() {
			$('#lightbox-loading').hide();
			$('#lightbox-image').fadeIn(function() {
				_show_image_data();
				_set_navigation();
			});
			_preload_neighbor_images();
		};
		/**
		 * Show the image information
		 *
		 */
		function _show_image_data() {
			$('#lightbox-container-image-data-box').slideDown('fast');
			$('#lightbox-image-details-caption').hide();
			if ( settings.imageArray[settings.activeImage][1] ) {
				$('#lightbox-image-details-caption').html(settings.imageArray[settings.activeImage][1]).show();
			}
			// If we have a image set, display 'Image X of X'
			if ( settings.imageArray.length > 1 ) {
				$('#lightbox-image-details-currentNumber').html(settings.txtImage + ' ' + ( settings.activeImage + 1 ) + ' ' + settings.txtOf + ' ' + settings.imageArray.length).show();
			}		
		}
		/**
		 * Display the button navigations - modified by Robert Blackwell to implement cycle_thru_images
		 *
		 */
		function _set_navigation() {
			$('#lightbox-nav').show();

			// Instead to define this configuration in CSS file, we define here. And it�s need to IE. Just.
			$('#lightbox-nav-btnPrev,#lightbox-nav-btnNext').css({ 'background' : 'transparent url(' + settings.imageBlank + ') no-repeat' });
			
			// Show the prev button, if not the first image in set or if cycling_thru_images
			if (( settings.activeImage != 0 )||(settings.cycle_thru_images)) {
				if ( settings.fixedNavigation ) {
					$('#lightbox-nav-btnPrev').css({ 'background' : 'url(' + settings.imageBtnPrev + ') left 15% no-repeat' })
						.unbind()
						.bind('click',function() {
							_set_prev_image();
							//settings.activeImage = settings.activeImage - 1;
							_set_image_to_view();
							return false;
						});
				} else {
					// Show the images button for Next buttons
					$('#lightbox-nav-btnPrev').unbind().hover(function() {
						$(this).css({ 'background' : 'url(' + settings.imageBtnPrev + ') left 15% no-repeat' });
					},function() {
						$(this).css({ 'background' : 'transparent url(' + settings.imageBlank + ') no-repeat' });
					}).show().bind('click',function() {
						_set_prev_image();
						//settings.activeImage = settings.activeImage - 1;
						_set_image_to_view();
						return false;
					});
				}
			}
			
			// Show the next button, if not the last image in set
			if (( settings.activeImage != ( settings.imageArray.length -1 ) )||(settings.cycle_thru_images)) {
				if ( settings.fixedNavigation ) {
					$('#lightbox-nav-btnNext').css({ 'background' : 'url(' + settings.imageBtnNext + ') right 15% no-repeat' })
						.unbind()
						.bind('click',function() {
							_set_next_image();
							//settings.activeImage = settings.activeImage + 1;
							_set_image_to_view();
							return false;
						});
				} else {
					// Show the images button for Next buttons
					$('#lightbox-nav-btnNext').unbind().hover(function() {
						$(this).css({ 'background' : 'url(' + settings.imageBtnNext + ') right 15% no-repeat' });
					},function() {
						$(this).css({ 'background' : 'transparent url(' + settings.imageBlank + ') no-repeat' });
					}).show().bind('click',function() {
						_set_next_image();
						//settings.activeImage = settings.activeImage + 1;
						_set_image_to_view();
						return false;
					});
				}
			}
			// Enable keyboard navigation
			_enable_keyboard_navigation();
		}
		/**
		 * Enable a support to keyboard navigation - modified by Robert Blackwell to use named function as handler
		 *
		 */
		function _enable_keyboard_navigation() {
			// $("#jquery-lightbox").bind("keydown", _keyboard_action);//Robert Blackwell
			$(document).bind("keydown", _keyboard_action);//Robert Blackwell
		}
		/**
		 * Disable the support to keyboard navigation. Modified by Robert Blackwell to unhooked named handler
		 *
		 */
		function _disable_keyboard_navigation() {
			// $("#jquery-lightbox").unbind("keydown", _keyboard_action); // Robert Blackwell
			$(document).unbind("keydown", _keyboard_action); // Robert Blackwell
		}
		/**
		 * Perform the keyboard actions. 
		 * Formward and back use arrow keys, or n/Next p/Prev
		 * Close is ESC, Cclose, xX 
		 * Stops the event proagating to other handlers
		 * On close disconnects itself from the keydown event. 
		 * On Close Calls _final() to remove the popup display
		 */
		function _keyboard_action(objEvent) {
			// To ie
			if(objEvent.originalEvent.repeat) {
				return
			}
			if (objEvent == null ){
				keycode = event.keyCode;
				escapeKey = 27;
			// To Mozilla
			} else {
				keycode = objEvent.keyCode;
				// Robert Blackwell - this was not working correctly on Safari
				escapeKey = (undefined != objEvent.DOM_VK_ESCAPE)? objEvent.DOM_VK_ESCAPE: 27;
			}
			// Get the key in lower case form
			key = String.fromCharCode(keycode).toLowerCase();
			// Verify the keys to close the ligthBox
			if ( ( key == settings.keyToClose ) || ( key == 'x' ) || ( keycode == escapeKey ) ) {
				//alert("should unbind at this point");
				_finish();
				//Robert Blackwell - unhook the specific handler and stop event propagation
				objEvent.stopPropagation();
				// $("#jquery-lightbox").unbind("keydown", _keyboard_action);
				$(document).unbind("keydown", _keyboard_action);
				return false;
			}
			// Verify the key to show the previous image
			if ( ( key == settings.keyToPrev ) || ( keycode == 37 ) ) {
				// If we�re not showing the first image, call the previous
				_set_prev_image();
				_set_image_to_view();
				_disable_keyboard_navigation();
				// Robert Blackwell stop event propagation
				objEvent.stopPropagation();
				return false;
			}
			// Verify the key to show the next image
			if ( ( key == settings.keyToNext ) || ( keycode == 39 ) ) {
				// If we�re not showing the last image, call the next
				_set_next_image();
				_set_image_to_view();
				_disable_keyboard_navigation();
				// Robert Blackwell - stop event propagation
				objEvent.stopPropagation();
				return false;
			}
		}
		/**
		 * Preload prev and next images being showed. Robert Blackwell - this needs mod to handle settings.cycle_thru_images
		 * correctly
		 *
		 */
		function _preload_neighbor_images() {
			if ( (settings.imageArray.length -1) > settings.activeImage ) {
				objNext = new Image();
				objNext.src = settings.imageArray[settings.activeImage + 1][0];
			}
			if ( settings.activeImage > 0 ) {
				objPrev = new Image();
				objPrev.src = settings.imageArray[settings.activeImage -1][0];
			}
		}
		/**
		 * Remove jQuery lightBox plugin HTML markup
		 *
		 */
		function _finish() {
		//alert("finish called");
			$('#jquery-lightbox').remove();
			$('#jquery-overlay').fadeOut(function() { $('#jquery-overlay').remove(); });
			// Show some elements to avoid conflict with overlay in IE. These elements appear above the overlay.
			$('embed, object, select').css({ 'visibility' : 'visible' });
		}
		/**
		 / THIRD FUNCTION
		 * getPageSize() by quirksmode.com
		 *
		 * @return Array Return an array with page width, height and window width, height
		 */
		function ___getPageSize() {
			var xScroll, yScroll;
			if (window.innerHeight && window.scrollMaxY) {	
				xScroll = window.innerWidth + window.scrollMaxX;
				yScroll = window.innerHeight + window.scrollMaxY;
			} else if (document.body.scrollHeight > document.body.offsetHeight){ // all but Explorer Mac
				xScroll = document.body.scrollWidth;
				yScroll = document.body.scrollHeight;
			} else { // Explorer Mac...would also work in Explorer 6 Strict, Mozilla and Safari
				xScroll = document.body.offsetWidth;
				yScroll = document.body.offsetHeight;
			}
			var windowWidth, windowHeight;
			if (self.innerHeight) {	// all except Explorer
				if(document.documentElement.clientWidth){
					windowWidth = document.documentElement.clientWidth; 
				} else {
					windowWidth = self.innerWidth;
				}
				windowHeight = self.innerHeight;
			} else if (document.documentElement && document.documentElement.clientHeight) { // Explorer 6 Strict Mode
				windowWidth = document.documentElement.clientWidth;
				windowHeight = document.documentElement.clientHeight;
			} else if (document.body) { // other Explorers
				windowWidth = document.body.clientWidth;
				windowHeight = document.body.clientHeight;
			}	
			// for small pages with total height less then height of the viewport
			if(yScroll < windowHeight){
				pageHeight = windowHeight;
			} else { 
				pageHeight = yScroll;
			}
			// for small pages with total width less then width of the viewport
			if(xScroll < windowWidth){	
				pageWidth = xScroll;		
			} else {
				pageWidth = windowWidth;
			}
			arrayPageSize = new Array(pageWidth,pageHeight,windowWidth,windowHeight);
			return arrayPageSize;
		};
		/**
		 / THIRD FUNCTION
		 * getPageScroll() by quirksmode.com
		 *
		 * @return Array Return an array with x,y page scroll values.
		 */
		function ___getPageScroll() {
			var xScroll, yScroll;
			if (self.pageYOffset) {
				yScroll = self.pageYOffset;
				xScroll = self.pageXOffset;
			} else if (document.documentElement && document.documentElement.scrollTop) {	 // Explorer 6 Strict
				yScroll = document.documentElement.scrollTop;
				xScroll = document.documentElement.scrollLeft;
			} else if (document.body) {// all other Explorers
				yScroll = document.body.scrollTop;
				xScroll = document.body.scrollLeft;	
			}
			arrayPageScroll = new Array(xScroll,yScroll);
			return arrayPageScroll;
		};
		 /**
		  * Stop the code execution from a escified time in milisecond
		  *
		  */
		 function ___pause(ms) {
			var date = new Date(); 
			curDate = null;
			do { var curDate = new Date(); }
			while ( curDate - date < ms);
		 };
		// Return the jQuery object for chaining. The unbind method is used to avoid click conflict when the plugin is called more than once
		return this.unbind('click').click(_initialize);
	};
})(jQuery); // Call and execute the function immediately passing the jQuery object